const toggleText = () => {

    const triggers = document.querySelectorAll('.js-toggle-text');

    triggers.forEach((trigger) => {
        const target = trigger.parentElement.querySelector('.toggle-text-content');
        if (!target) return;



        trigger.addEventListener('click', (e) => {
            e.preventDefault();

            const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

            trigger.setAttribute('aria-expanded', String(!isExpanded));
            target.classList.toggle('is-open', !isExpanded);
            trigger.classList.toggle('is-open', !isExpanded);

            const textMore = trigger.dataset.textMore;
            const textLess = trigger.dataset.textLess;
            if (textMore && textLess) {
                const label = trigger.querySelector('.toggle-text-label') || trigger;
                label.textContent = isExpanded ? textMore : textLess;
            }
        });
    });
}

export default toggleText;
